<template>
  <div class="header header--home" v-if="!isMobile">
		<SidebarTrigger class="mb-2" />
    <header-company-placeholder></header-company-placeholder>
    <header-support-block class="header__support-block"></header-support-block>
    <header-user-block></header-user-block>
  </div>
  <div class="header-mobile header-mobile--home" v-else>
    <logo class="header-mobile__logo"></logo>
    <router-link to="/cabinet/profile" class="header-mobile__profile">
      <svg
        width="29"
        height="29"
        viewBox="0 0 29 29"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="29" height="29" rx="7" fill="#64748B" />
        <path
          d="M14.5784 22.5731C10.0668 22.5731 6.39648 18.8802 6.39648 14.3407C6.39648 9.80083 10.0668 6.10742 14.5784 6.10742C19.0913 6.10742 22.7627 9.80055 22.7627 14.3407C22.7627 18.8802 19.0913 22.5731 14.5784 22.5731ZM14.5784 7.48819C10.8281 7.48819 7.77698 10.5621 7.77698 14.3407C7.77698 18.1187 10.8278 21.1923 14.5784 21.1923C18.33 21.1923 21.3822 18.1187 21.3822 14.3407C21.3822 10.5624 18.33 7.48819 14.5784 7.48819Z"
          fill="white"
        />
        <path
          d="M24.2584 24.8034C24.6397 24.8034 24.9487 24.4943 24.9487 24.113V24.1715C24.9487 21.6778 23.5677 19.7883 20.9543 18.707C20.6021 18.5611 20.1986 18.7287 20.0527 19.0806C19.9071 19.4328 20.0744 19.8366 20.4266 19.9822C22.5405 20.8572 23.5683 22.2273 23.5683 24.1713V24.113C23.568 24.4943 23.877 24.8034 24.2584 24.8034Z"
          fill="white"
        />
        <path
          d="M24.2588 24.8034C24.6402 24.8034 24.9492 24.4943 24.9492 24.113V24.1715C24.9492 21.6778 23.5682 19.7883 20.9547 18.707C20.6025 18.5611 20.1989 18.7287 20.0531 19.0806C19.9075 19.4328 20.0748 19.8366 20.427 19.9822C22.541 20.8572 23.5687 22.2273 23.5687 24.1713V24.113C23.5684 24.4943 23.8775 24.8034 24.2588 24.8034Z"
          fill="white"
        />
        <path
          d="M4.69038 24.8034C4.30907 24.8034 4 24.4943 4 24.113V24.1715C4 21.6778 5.38104 19.7883 7.99451 18.707C8.3467 18.5611 8.75028 18.7287 8.89615 19.0806C9.04176 19.4328 8.87445 19.8366 8.52225 19.9822C6.40824 20.8572 5.38049 22.2273 5.38049 24.1713V24.113C5.38077 24.4943 5.0717 24.8034 4.69038 24.8034Z"
          fill="white"
        />
        <path
          d="M12.458 14.1776H11.5256C11.144 14.1776 10.835 13.8686 10.835 13.487C10.835 13.1059 11.144 12.7969 11.5256 12.7969H12.458C12.8394 12.7969 13.1484 13.1059 13.1484 13.487C13.1484 13.8686 12.8394 14.1776 12.458 14.1776Z"
          fill="white"
        />
        <path
          d="M17.7515 14.1776H16.8188C16.4375 14.1776 16.1284 13.8686 16.1284 13.487C16.1284 13.1059 16.4375 12.7969 16.8188 12.7969H17.7515C18.1328 12.7969 18.4419 13.1059 18.4419 13.487C18.4419 13.8686 18.1328 14.1776 17.7515 14.1776Z"
          fill="white"
        />
        <path
          d="M16.2858 16.1191C15.6905 17.3096 14.5001 17.3096 14.5001 17.3096C14.5001 17.3096 13.3096 17.3096 12.7144 16.1191"
          stroke="white"
          stroke-linecap="round"
        />
      </svg>
    </router-link>
    <div class="header-mobile__menu-button" @click="$emit('toggleSidebar')">
      <svg
        width="27"
        height="18"
        viewBox="0 0 27 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="27" height="2" rx="1" fill="#465A8B" />
        <rect width="27" height="2" rx="1" fill="#465A8B" />
        <rect y="16" width="27" height="2" rx="1" fill="#465A8B" />
        <rect y="8" width="18" height="2" rx="1" fill="#465A8B" />
        <rect y="8" width="18" height="2" rx="1" fill="#465A8B" />
      </svg>
    </div>
  </div>
</template>

<script>
import HeaderCompanyPlaceholder from '@vue-app/components/header/parts/HeaderCompanyPlaceholder.vue'
import HeaderSupportBlock from '@vue-app/components/header/parts/HeaderSupportBlock.vue'
import HeaderUserBlock from '@vue-app/components/header/parts/HeaderUserBlock.vue'
import responsiveMixin from '@vue-app/mixins/responsive-mixin'
import Logo from '@vue-app/components/base/Logo.vue'
import { SidebarTrigger } from '@ui/sidebar'

export default {
  name: 'HomeHeader',
  components: {
    HeaderUserBlock,
    HeaderSupportBlock,
    HeaderCompanyPlaceholder,
    Logo,
		SidebarTrigger
  },
  mixins: [responsiveMixin],
  emits: ['toggleSidebar'],
}
</script>

<style lang="scss" scoped>
.header {
  &--home {
    display: flex;
    align-items: center;
  }

  &--home & {
    &__support-block {
      margin-left: auto;
      margin-right: 60px;
    }
  }
}
@media screen and (max-width: 992px) {
  .header-mobile {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 36px 0;
    &__profile {
      margin-left: auto;
      margin-right: 27px;
      cursor: pointer;

      &:hover {
        opacity: 0.8;
      }
    }

    &__menu-button {
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      &:hover {
        opacity: 0.8;
      }
    }
  }
}
</style>
